var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB1ElectricityOfHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.33 41l18.19-20.5 3 2.65L30.22 37H51L36 54.38 39.78 58H29V47.68l4.05 3.95L42.25 41H21.33zM73 25.89V69H3V25.89L38.38 3.62 73 25.89zm-4 2.18L38.35 8.37 7 28.1V65h62V28.07z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B1_Electricity_of_home.d724cdf7.svg";
export { SvgB1ElectricityOfHome as ReactComponent };